import { useState } from "react";
import { useAuth } from "../lib/auth";
import { getApiErrorMessage } from "../lib/api";

export default function ImpersonationBanner() {
  const { user, isImpersonating, exitImpersonation } = useAuth();
  const [exiting, setExiting] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  if (!isImpersonating || !user) return null;

  async function onExit() {
    setErr(null);
    setExiting(true);
    try {
      await exitImpersonation();
      // Land back on the admin user detail of the person we were impersonating.
      window.location.assign(`/admin/users/${user!.id}`);
    } catch (e) {
      setErr(getApiErrorMessage(e, "Failed to exit impersonation"));
      setExiting(false);
    }
  }

  return (
    <div className="bg-red-600 text-white text-sm">
      <div className="flex items-center justify-between gap-3 px-4 md:px-6 py-2">
        <div className="flex items-center gap-2 min-w-0">
          <svg
            aria-hidden="true"
            viewBox="0 0 20 20"
            fill="currentColor"
            className="w-4 h-4 shrink-0"
          >
            <path
              fillRule="evenodd"
              d="M8.485 3.495c.673-1.166 2.357-1.166 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.346 0-2.189-1.458-1.515-2.625L8.485 3.495zM10 7a1 1 0 011 1v3a1 1 0 11-2 0V8a1 1 0 011-1zm0 7a1 1 0 100 2 1 1 0 000-2z"
              clipRule="evenodd"
            />
          </svg>
          <span className="truncate">
            Impersonating <span className="font-semibold">{user.email}</span>
          </span>
          {err && <span className="text-red-100">· {err}</span>}
        </div>
        <button
          type="button"
          onClick={onExit}
          disabled={exiting}
          className="shrink-0 inline-flex items-center rounded-md bg-white/15 hover:bg-white/25 px-3 py-1 font-medium disabled:opacity-60 disabled:cursor-not-allowed"
        >
          {exiting ? "Exiting…" : "Exit impersonation"}
        </button>
      </div>
    </div>
  );
}
